import update from "immutability-helper";

export const ROUTES = {
  UNIT_LIBRARY: "units",
  LE_LIBRARY: "tasks",
};
export const DEFAULT_CHILD_ROUTE = ROUTES.UNIT_LIBRARY;

export const NAME = "SCHOOL_LIBRARY";

export const UPDATE_CHILD_ROUTE = `UPDATE_CHILD_ROUTE ${NAME}`;
export const UPDATE_SELECTED_COURSE = `UPDATE_SELECTED_COURSE ${NAME}`;
export const UPDATE_COURSE_FILTER_SEARCH_TEXT = `UPDATE_COURSE_FILTER_SEARCH_TEXT ${NAME}`;
export const UPDATE_CLASS_FILTER_SEARCH_TEXT = `UPDATE_CLASS_FILTER_SEARCH_TEXT ${NAME}`;
export const UPDATE_CREATOR_FILTER_SEARCH_TEXT = `UPDATE_CREATOR_FILTER_SEARCH_TEXT ${NAME}`;

export const updateChildRoute = data => {
  return { type: UPDATE_CHILD_ROUTE, data: data };
};

export const updateSelectedCourse = data => {
  return { type: UPDATE_SELECTED_COURSE, data: data };
};

export const updateCourseFilterSearchText = data => {
  return { type: UPDATE_COURSE_FILTER_SEARCH_TEXT, data: data };
};
export const updateClassFilterSearchText = data => {
  return { type: UPDATE_CLASS_FILTER_SEARCH_TEXT, data: data };
};
export const updateCreatorFilterSearchText = data => {
  return { type: UPDATE_CREATOR_FILTER_SEARCH_TEXT, data: data };
};

const REDUCER_HANDLERS = {
  [UPDATE_CHILD_ROUTE]: (state, action) => {
    const newRoute = action.data;
    return update(state, {
      childRoute: {
        $set: newRoute,
      },
    });
  },
  [UPDATE_SELECTED_COURSE]: (state, action) => {
    const newCourseSelection = action.data;
    return update(state, {
      selectedCourse: {
        $set: newCourseSelection,
      },
    });
  },
  [UPDATE_COURSE_FILTER_SEARCH_TEXT]: (state, action) => {
    const searchText = action.data;
    return update(state, {
      courseSearchText: {
        $set: searchText,
      },
    });
  },
  [UPDATE_CLASS_FILTER_SEARCH_TEXT]: (state, action) => {
    const searchText = action.data;
    return update(state, {
      classSearchText: {
        $set: searchText,
      },
    });
  },
  [UPDATE_CREATOR_FILTER_SEARCH_TEXT]: (state, action) => {
    const searchText = action.data;
    return update(state, {
      creatorSearchText: {
        $set: searchText,
      },
    });
  },
};

const initialState = {
  childRoute: DEFAULT_CHILD_ROUTE,
  selectedCourse: {},
  courseSearchText: "",
  classSearchText: "",
  creatorSearchText: "",
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
